import api from "../../../services/apiClient"
import type { TagFormValues } from "../models/tag"

const BASE = "post-tag"

export const tagApi = {
  getList: async (params?: Record<string, unknown>) => {
    const { data } = await api.get(BASE, { params })
    return data?.data ?? data
  },
  getById: async (id: number) => {
    const { data } = await api.get(`${BASE}/${id}`)
    return data?.data ?? data
  },
  create: async (values: TagFormValues) => {
    const { data } = await api.post(`${BASE}/create`, values)
    return data?.data ?? data
  },
  update: async (id: number, values: Partial<TagFormValues>) => {
    const { data } = await api.post(`${BASE}/update/${id}`, values)
    return data?.data ?? data
  },
  delete: async (id: number) => {
    const { data } = await api.delete(`${BASE}/delete/${id}`)
    return data
  },
}
